import React, { Fragment, useState, useEffect, useRef } from 'react';
import { Btn, Spinner } from '../../../../../AbstractElements';
import { Card, CardBody, Col, Table, Form, FormGroup, Label, Row, CardHeader } from 'reactstrap';
import axios from 'axios';
import config from '../../../../../config';
import { toast } from 'react-toastify';
import ReactPaginate from 'react-paginate';
import * as XLSX from 'xlsx';
import jsPDF from 'jspdf';
import 'jspdf-autotable';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSort, faSortUp, faSortDown } from '@fortawesome/free-solid-svg-icons';
import { faFileExcel, faFilePdf } from '@fortawesome/free-solid-svg-icons';

const TenantItemwiseView = () => {

    if (localStorage.getItem("accessReports") !== "1") {
        alert('You are not authorized to view this page');
        window.history.back(); // Navigate back to the previous URL
    }

    const getYesterdayDate = () => {
        const yesterday = new Date();
        yesterday.setDate(yesterday.getDate() - 1);
        return yesterday.toISOString().split('T')[0]; // Format as YYYY-MM-DD
    };

    const concessionaire_id = localStorage.getItem("concessionaireId");
    const property_access = localStorage.getItem("propertyAccess");
    const [propertyAccessNames, setPropertyAccesssNames] = useState('');
    const login_name = localStorage.getItem("loginName");
    const login_id = localStorage.getItem("loginId");
    const [startDate, setStartDate] = useState(getYesterdayDate());
    const [endDate, setEndDate] = useState(getYesterdayDate());
    const [properties, setProperties] = useState([]);
    const [categories, setCategories] = useState([]);
    const [group_name, setGroupName] = useState('');
    const [groups, setGroups] = useState([]);
    const [allSubcategories, setAllSubcategories] = useState([]);
    const [subcategories, setSubcategories] = useState([]);
    const [allTenants, setAllTenants] = useState([]);
    const [tenants, setTenants] = useState([]);
    const [allFloors, setAllFloors] = useState([]);
    const [floors, setFloors] = useState([]);
    const [property_id, setPropertyId] = useState('');
    const [category_id, setCategoryId] = useState('');
    const [subcategory_id, setSubcategoryId] = useState('');
    const [tenant_id, setTenantId] = useState('');
    const [selectedFloor, setSelectedFloor] = useState('');
    const [reportData, setReportData] = useState([]);
    const [currentPage, setCurrentPage] = useState(0);
    const [itemsPerPage] = useState(50);
    const [validationMessage, setValidationMessage] = useState('');
    const [loading, setLoading] = useState(false)
    const today = new Date().toISOString().split('T')[0];
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });

    const [tooltip, setTooltip] = useState('');

    const handleMouseEnter = (text) => setTooltip(text);
    const handleMouseLeave = () => setTooltip('');


    const [dropdownOpen, setDropdownOpen] = useState(false);

    const dropdownRef = useRef(null);
    const [searchTenant, setSearchTenant] = useState('');

    const toggleDropdown = () => {
        setDropdownOpen(!dropdownOpen);
    };


    const token = localStorage.getItem("sessiontoken");
    const configheader = {
        headers: {
            Authorization: `${token}`
        }
    };

    // 🔽 Close dropdown when clicking outside
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setDropdownOpen(false);
            }
        };

        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getpropertybyconcessionaire`, { property_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setProperties(response.data);
                const propertyNames = response.data.map(property => property.property_name).join(',');
                setPropertyAccesssNames(propertyNames);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getgroupnames`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setGroups(response.data)
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        axios
            .post(`${config.hostname}/category/getcategorybyconcessionaire`, { category_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setCategories(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        axios
            .post(`${config.hostname}/subcategory/getsubcategorybyconcessionaire`, { subcategory_concessionaire_id: concessionaire_id }, configheader)
            .then((response) => {
                setAllSubcategories(response.data);
                setSubcategories(response.data); // Initial set to all subcategories
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);


    useEffect(() => {
        let filteredSubcategories = allSubcategories;

        if (category_id !== '') {
            filteredSubcategories = filteredSubcategories.filter(subcategory => subcategory.category_id._id === category_id);
        }

        setSubcategories(filteredSubcategories);
    }, [category_id]);

    useEffect(() => {
        axios
            .post(`${config.hostname}/tenant/getenantsbyconcessionaire`, { tenant_concessionaire_id: concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllTenants(response.data);
                setTenants(response.data);
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredTenants = allTenants;

        if (group_name !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_group_name === group_name);
        }

        if (category_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_category_id._id === category_id);
        }

        if (property_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_property_id._id === property_id);
        }

        if (subcategory_id !== '') {
            filteredTenants = filteredTenants.filter(tenant => tenant.tenant_subcategory_id._id === subcategory_id);
        }

        setTenants(filteredTenants);
    }, [group_name, property_id, category_id, subcategory_id, allTenants]);



    useEffect(() => {
        axios
            .post(`${config.hostname}/property/getfloorsbyconcessionaire`, { concessionaire_id, property_id: property_access }, configheader)
            .then((response) => {
                setAllFloors(response.data);
                setFloors(getUniqueFloors(response.data));
            })
            .catch((error) => {
                console.log(error);
            });
    }, []);

    useEffect(() => {
        let filteredFloors = allFloors;

        if (property_id !== '') {
            filteredFloors = filteredFloors.filter(floor => floor.property_id === property_id);
        }

        setFloors(getUniqueFloors(filteredFloors));
    }, [property_id]);

    const getUniqueFloors = (floors) => {
        const floorNames = new Set();
        return floors.filter(floor => {
            if (!floorNames.has(floor.floor_id.floor_name)) {
                floorNames.add(floor.floor_id.floor_name);
                return true;
            }
            return false;
        });
    };


    const filteredTenants = tenants.filter((tenant) => {
        if (!searchTenant.trim()) return true;

        const search = searchTenant.trim().toLowerCase();

        const name = (tenant.tenant_name || "").toLowerCase();
        const code = (tenant.tenant_code || "").toLowerCase(); // or tenant.tenant_code / tenant_code

        return name.includes(search) || code.includes(search);
    });


    const generateReport = async (e) => {
        e.preventDefault();

        if (endDate < startDate) {
            setValidationMessage("End date cannot be less than start date");
            return;
        } else {
            setValidationMessage("");
        }

        const category_name =
            category_id !== ""
                ? categories.find((c) => c._id === category_id)?.category_name
                : "";
        const property_name =
            property_id !== ""
                ? properties.find((p) => p._id === property_id)?.property_name
                : "";
        const subcategory_name =
            subcategory_id !== ""
                ? subcategories.find((s) => s._id === subcategory_id)?.subcategory_name
                : "";
        const tenant_name =
            tenant_id !== "" ? tenants.find((t) => t._id === tenant_id)?.tenant_store_name : "";

        const data = {
            concessionaire_id,
            property_access: propertyAccessNames,
            start_date: startDate,
            end_date: endDate,
            group_name,
            category_name,
            property_name,
            subcategory_name,
            tenant_id: tenant_id,
            floor: selectedFloor,
        };

        setLoading(true);

        axios
            .post(`${config.hostname}/reports/gettenantitemwisereport`, data, configheader)
            .then((response) => {
                const rows = response?.data || [];      // <-- IMPORTANT
                // <-- PIVOT HERE
                setReportData(rows);
                setLoading(false);
                insertToLog(" generated Tenant Item wise report");
            })
            .catch((error) => {
                toast.error("Error");
                setLoading(false);
                console.log(error);
            });
    };

    const insertToLog = (task) => {
        const data = {
            created_by: login_id,
            concessionaire_id: concessionaire_id,
            module: "Reports",
            task: login_name + task
        }
        axios
            .post(`${config.hostname}/log`, data, configheader)
            .then(() => {
                console.log("inserted to log table")
            })
            .catch((error) => {
                toast.error('Error')
                console.log(error);

            });
    }


    const handleStartDateChange = (e) => {
        setStartDate(e.target.value);
        setReportData([]);
        setCurrentPage(0);
    };

    const handleEndDateChange = (e) => {
        setEndDate(e.target.value);
        setReportData([]);
        setCurrentPage(0);
    };

    const handleGroupChange = (e) => {
        setGroupName(e.target.value);
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
    };

    const handlePropertyChange = (e) => {
        setPropertyId(e.target.value);
        setTenantId('');
        setSelectedFloor('');
        setReportData([]);
        setCurrentPage(0);
    };

    const handleCategoryChange = (e) => {
        setCategoryId(e.target.value);
        setSubcategoryId('')
        setTenantId('');
        setReportData([]);
        setCurrentPage(0);
    };

    const handleSubCategoryChange = (e) => {
        setSubcategoryId(e.target.value);
        setTenantId('')
        setReportData([]);
        setCurrentPage(0);
    };


    const handleTenantChange = (e) => {

        setTenantId(e.target.value)

        setReportData([]);
        setCurrentPage(0);
    };


    const handleFloorChange = (e) => {
        setSelectedFloor(e.target.value);
        setReportData([]);
        setCurrentPage(0);
    };

    const handlePageClick = (data) => {
        setCurrentPage(data.selected);
    };

    //const offset = currentPage * itemsPerPage;
    const pageCount = Math.ceil(reportData.length / itemsPerPage);

    const totalTransactionCount = reportData.reduce((sum, item) => sum + item.transaction_count, 0);
    const totalNetSales = reportData.reduce((sum, item) => sum + item.net_sales, 0);


    const sortedReportData = React.useMemo(() => {
        let sortableData = [...reportData];
        if (sortConfig.key !== '') {
            sortableData.sort((a, b) => {
                if (a[sortConfig.key] < b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? -1 : 1;
                }
                if (a[sortConfig.key] > b[sortConfig.key]) {
                    return sortConfig.direction === 'asc' ? 1 : -1;
                }
                return 0;
            });
        }
        return sortableData;
    }, [reportData, sortConfig]);

    const currentPageData = sortedReportData.slice(currentPage * itemsPerPage, (currentPage + 1) * itemsPerPage);

    const requestSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key && sortConfig.direction === 'asc') {
            direction = 'desc';
        }
        setSortConfig({ key, direction });
    };

    const getSortIcon = key => {
        if (sortConfig.key === key) {
            if (sortConfig.direction === 'asc') {
                return <FontAwesomeIcon icon={faSortUp} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
            if (sortConfig.direction === 'desc') {
                return <FontAwesomeIcon icon={faSortDown} style={{ fontSize: '0.5em', fontWeight: 'normal' }} />;
            }
        }

    };


    const handleExport = (format) => {
        if (reportData.length > 0) {
            if (format === 'excel') {
                exportToExcel();
                insertToLog(" exported Tenant Item wise report to excel");
            } else if (format === 'pdf') {
                exportToPDF();
                insertToLog(" exported Tenant Item wise report to  pdf")
            }
        }
    };


    const exportToExcel = () => {
        try {
            if (!reportData || reportData.length === 0) {
                toast?.error?.("No data to export");
                return;
            }

            // ---- Build filter lines (all mandatory in your API, but show anyway) ----
            const filterLines = [];
            if (startDate || endDate) filterLines.push(["Date Range", `${startDate}  to  ${endDate}`]);
            if (tenant_id) {
                const tName = tenants?.find((t) => t._id === tenant_id)?.tenant_store_name || tenant_id;
                filterLines.push(["Tenant", tName]);
            }

            const headers = [
                "Transaction Date",
                "Receipt No",
                "SKU Code",
                "SKU Name",
                "Qty",
                "Rate",
                "Gross",
                "Net",
                "Tax",
                "Discount",
            ];

            const colCount = headers.length;

            const padRow = (arr) => {
                const r = Array(colCount).fill("");
                for (let i = 0; i < Math.min(arr.length, colCount); i++) r[i] = arr[i];
                return r;
            };

            // ---- Create AOA sheet ----
            const sheetData = [];

            // Heading
            sheetData.push(padRow(["Tenant Item wise Report"]));
            sheetData.push(padRow([""]));

            // Filters
            filterLines.forEach((l) => sheetData.push(padRow(l)));
            if (filterLines.length) sheetData.push(padRow([""]));

            // Table header row index for freezing
            const headerRowIndex = sheetData.length;
            sheetData.push(headers);

            // Data rows
            sheetData.push(
                ...reportData.map((r) => [
                    r.transaction_date ? fmtDateTime(r.transaction_date) : "",
                    r.receipt_number || "",
                    r.sku_code || "",
                    r.sku_name || "",
                    Number(r.qty || 0),
                    Number(r.rate || 0),
                    Number(r.gross || 0),
                    Number(r.net || 0),
                    Number(r.tax || 0),
                    Number(r.discount || 0),
                ])
            );

            // Totals row (FULL data totals)
            const totals = reportData.reduce(
                (acc, r) => {
                    acc.qty += Number(r.qty || 0);
                    acc.gross += Number(r.gross || 0);
                    acc.net += Number(r.net || 0);
                    acc.tax += Number(r.tax || 0);
                    acc.discount += Number(r.discount || 0);
                    return acc;
                },
                { qty: 0, gross: 0, net: 0, tax: 0, discount: 0 }
            );

            sheetData.push([
                "Total",
                "",
                "",
                "",
                totals.qty,
                "",
                totals.gross,
                totals.net,
                totals.tax,
                totals.discount,
            ]);

            // ---- Worksheet ----
            const ws = XLSX.utils.aoa_to_sheet(sheetData);

            // Merge heading across all columns
            ws["!merges"] = ws["!merges"] || [];
            ws["!merges"].push({
                s: { r: 0, c: 0 },
                e: { r: 0, c: colCount - 1 },
            });

            // Column widths
            ws["!cols"] = [
                { wch: 16 }, // Transaction Date
                { wch: 16 }, // Receipt No
                { wch: 14 }, // SKU Code
                { wch: 30 }, // SKU Name
                { wch: 8 },  // Qty
                { wch: 10 }, // Rate
                { wch: 14 }, // Gross
                { wch: 14 }, // Net
                { wch: 12 }, // Tax
                { wch: 12 }, // Discount
            ];

            // Freeze: rows up to header + keep first 4 columns
            ws["!freeze"] = { xSplit: 4, ySplit: headerRowIndex + 1 };

            // Number format for numeric columns (Qty + money cols) from data rows onward
            const range = XLSX.utils.decode_range(ws["!ref"]);
            const firstDataRow = headerRowIndex + 1; // row after table header
            const qtyCol = 4; // 0-based
            const firstMoneyCol = 5; // Rate
            for (let R = firstDataRow; R <= range.e.r; R++) {
                // Qty as integer
                const qtyAddr = XLSX.utils.encode_cell({ r: R, c: qtyCol });
                if (ws[qtyAddr]) ws[qtyAddr].z = "0";

                // Rate..Discount as money
                for (let C = firstMoneyCol; C <= range.e.c; C++) {
                    const addr = XLSX.utils.encode_cell({ r: R, c: C });
                    if (ws[addr]) ws[addr].z = "#,##0.00";
                }
            }

            const wb = XLSX.utils.book_new();
            XLSX.utils.book_append_sheet(wb, ws, "Transaction Items");

            const fileName = `Tenant_Item_wise_Report_${startDate}_to_${endDate}.xlsx`;
            XLSX.writeFile(wb, fileName);
        } catch (err) {
            console.error("Export Excel error:", err);
            toast?.error?.("Excel export failed");
        }
    };




    const exportToPDF = () => {
        const doc = new jsPDF('p', 'pt', 'a4');
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        // Add a heading with a reduced font size
        doc.setFontSize(13); // Reduced font size
        doc.setFont('helvetica', 'bold');
        doc.text('Day wise Report', pageWidth / 2, 20, { align: 'center' });

        // Reset font for metadata with a smaller font size
        doc.setFontSize(7); // Reduced font size by 2
        doc.setFont('helvetica', 'normal');

        // Conditional date display
        const dateDisplay = startDate === endDate
            ? [`Date: ${startDate}`]
            : [`From: ${startDate} To: ${endDate}`];

        // Add additional information at the top of the PDF
        const lineHeight = 8; // Reduced line height
        const startX = 10;
        let startY = 40;

        const metadata = [
            ...dateDisplay.map(item => [item]),
            `Property: ${property_id ? properties.find(p => p._id === property_id)?.property_name : 'All'}`,
            `Category: ${category_id ? categories.find(s => s._id === category_id)?.category_name : 'All'}`,
            `Group: ${group_name ? group_name : 'All'}`,
            `Subcategory: ${subcategory_id ? subcategories.find(s => s._id === subcategory_id)?.subcategory_name : 'All'}`,
            `Tenant: ${tenant_id ? tenants.find(t => t._id === tenant_id)?.tenant_name : 'All'}`,
            `Floor: ${selectedFloor || 'All'}`,
            `Exported By: ${login_name}`,
            `Exported On: ${new Date().toLocaleString()}`,
        ];

        metadata.forEach((text, index) => {
            doc.text(text, startX, startY + (index * lineHeight));
        });

        // Add a space before the table
        startY += metadata.length * lineHeight + 10;

        // Function to split data into chunks
        const chunkArray = (array, chunkSize) => {
            const result = [];
            for (let i = 0; i < array.length; i += chunkSize) {
                result.push(array.slice(i, i + chunkSize));
            }
            return result;
        };

        // Optimize chunk size to fit more rows per page and reduce the number of pages
        const rowsPerPage = Math.floor((pageHeight - startY - 30) / 10);
        const chunkSize = rowsPerPage * 3; // Three tables per page
        const dataChunks = chunkArray(reportData, chunkSize);

        // Footer details
        const totalTransactionCount = reportData.reduce((sum, item) => sum + item.transaction_count, 0);
        const totalNetSales = reportData.reduce((sum, item) => sum + item.net_sales, 0);


        const addFooters = (doc, pageCount) => {
            for (let i = 1; i <= pageCount; i++) {
                doc.setPage(i);
                const pageHeight = doc.internal.pageSize.height || doc.internal.pageSize.getHeight();
                doc.setFontSize(7); // Smaller font size for page number
                doc.text(`Page ${i} of ${pageCount}`, pageWidth / 2, pageHeight - 20, { align: 'center' });
            }
        };

        const addTotalRow = () => {
            doc.autoTable({
                startY: doc.lastAutoTable.finalY + 10,
                head: [['Total', '', '', '', '', '', '', totalTransactionCount, totalNetSales.toLocaleString()]],
                headStyles: { fillColor: [0, 71, 178], textColor: [255, 255, 255], fontSize: 8 },
                bodyStyles: { fillColor: [0, 71, 178], textColor: [255, 255, 255], fontSize: 8 },
                theme: 'grid',
                tableLineWidth: 0.5,
                tableLineColor: [255, 255, 255],
                margin: { top: 10 },
            });
        };

        const processChunk = (chunkIndex) => {
            if (chunkIndex >= dataChunks.length) {
                addTotalRow();
                addFooters(doc, doc.internal.getNumberOfPages());
                doc.save('DaywiseReport.pdf', { compress: true });
                return;
            }

            if (chunkIndex > 0) {
                doc.addPage();
            }

            doc.autoTable({
                startY: chunkIndex === 0 ? startY : 20,
                head: [['Tenant Name', 'Group Name', 'Tenant Code', 'Unit Code', 'Property', 'Subcategory',]],
                body: dataChunks[chunkIndex].map(item => [
                    item.tenant_name,
                    item.tenant_code,
                    item.property_name,
                    item.subcategory_name,
                    item.floor,
                    item.transaction_date,
                    item.transaction_count,
                    // item.net_sales.toFixed(2).toLocaleString()
                    Number(item.net_sales.toFixed(2)).toLocaleString()

                ]),
                headStyles: { fontSize: 7 },
                bodyStyles: { fontSize: 7 },
                margin: { top: 10, bottom: 10, left: 10, right: 10 }, // Reduced margins to minimize blank space
                tableWidth: 'auto', // Adjust the table width to fit the content
                pageBreak: 'auto', // Automatically handle page breaks
            });

            // Process next chunk after a short delay
            setTimeout(() => processChunk(chunkIndex + 1), 0);
        };

        // Start processing chunks
        processChunk(0);
    };

    const reset = () => {
        setStartDate('')
        setEndDate('')
        setPropertyId('');
        setCategoryId('');
        setSubcategoryId('');
        setGroupName('');
        setTenantId('');
        setSelectedFloor('');
        setSearchTenant('');
        setDropdownOpen(false);
        setReportData([])

    }

    // 24 hour columns
    const HOUR_COLS = Array.from({ length: 24 }, (_, h) => ({
        key: `h${h}`,              // field name in pivot row
        label: `${h}-${h + 1}hr`,  // header text
        hour: h,
    }));

    const fmtMoney = (v) =>
        (v ?? 0).toLocaleString(undefined, { minimumFractionDigits: 2, maximumFractionDigits: 2 });

    /**
     * rows from API look like:
     * { hour: 0..23, hour_range:"0-1hr", tenant_name, tenant_code, property_name, category_name, subcategory_name,
     *   total_net_sales, total_gross_sales }
     *
     * returns pivoted rows:
     * { tenant_name, tenant_code, property_name, category_name, subcategory_name, h0..h23, total_net_sales }
     */
    const fmtDateTime = (d) => {
        if (!d) return "";
        const dt = new Date(d);
        if (isNaN(dt.getTime())) return String(d);

        const dd = String(dt.getDate()).padStart(2, "0");
        const mm = String(dt.getMonth() + 1).padStart(2, "0");
        const yyyy = dt.getFullYear();

        // if you also want time, uncomment:
        // const hh = String(dt.getHours()).padStart(2, "0");
        // const mi = String(dt.getMinutes()).padStart(2, "0");
        // const ss = String(dt.getSeconds()).padStart(2, "0");
        // return `${dd}/${mm}/${yyyy} ${hh}:${mi}:${ss}`;

        return `${dd}/${mm}/${yyyy}`;
    };



    return (
        <Fragment>
            <Form className='theme-form' onSubmit={generateReport}>
                <Card>
                    <CardBody>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="startdate">Start Date</Label>
                                    <input className="form-control digits"
                                        id="startdate" type="date" name="startdate" value={startDate}
                                        max={today} onChange={handleStartDateChange} required />
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="enddate">End Date</Label>
                                    <input className="form-control digits"
                                        id="startdate" type="date" name="startdate" value={endDate}
                                        max={today} onChange={handleEndDateChange} required />
                                </FormGroup>
                                {validationMessage && (
                                    <span className="text-danger">{validationMessage}</span>
                                )}
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="property_id">Property</Label>
                                    <select name="property_id" id="property_id" className="form-control"
                                        value={property_id} onChange={handlePropertyChange}>
                                        <option value="">All</option>
                                        {properties.map(property => (
                                            <option key={property._id} value={property._id}>{property.property_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>

                        </Row>
                        <Row>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="category_id">Category</Label>
                                    <select name="category_id" id="category_id" className="form-control"
                                        value={category_id} onChange={handleCategoryChange}>
                                        <option value="">All</option>
                                        {categories.map(category => (
                                            <option key={category._id} value={category._id}>{category.category_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Sub Category</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={subcategory_id} onChange={handleSubCategoryChange}>
                                        <option value="">All</option>
                                        {subcategories.map(subcategory => (
                                            <option key={subcategory._id} value={subcategory._id}>{subcategory.subcategory_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="subcategory_id">Group</Label>
                                    <select name="subcategory_id" id="subcategory_id" className="form-control"
                                        value={group_name} onChange={handleGroupChange}>
                                        <option value="">All</option>
                                        {groups.map((group, index) => (
                                            <option key={index} value={group}>{group}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                            <Col>
                                <FormGroup className="mb-3">
                                    <Label htmlFor="tenant_id">Tenant</Label>
                                    <select name="tenant_id" id="tenant_id" className="form-control"
                                        value={tenant_id} onChange={handleTenantChange} required>
                                        <option value="">Select Teanant</option>
                                        {tenants.map(tenant => (
                                            <option key={tenant._id} value={tenant._id}>{tenant.tenant_store_name}</option>
                                        ))}
                                    </select>
                                </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col >
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', type: "submit" }} >Generate Report</Btn>
                                <Btn attrBtn={{ color: 'primary', className: 'me-3', onClick: reset }} >Reset</Btn>
                            </Col>

                        </Row>


                    </CardBody>
                </Card>
            </Form>
            {loading === true ? (
                <div className="loader-box">
                    <Spinner attrSpinner={{ className: 'loader-3' }} />
                </div>

            ) : (
                <Card>
                    <CardHeader>
                        <Row className="justify-content-end">
                            <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => handleExport('excel'),
                                        onMouseEnter: () => handleMouseEnter('Export to Excel'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFileExcel} size="lg" />
                                </Btn>
                                {tooltip === 'Export to Excel' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 1,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}
                            </Col>
                            {/* <Col xs="auto" style={{ position: 'relative' }}>
                                <Btn
                                    attrBtn={{
                                        color: 'primary',
                                        type: 'button',
                                        onClick: () => handleExport('pdf'),
                                        onMouseEnter: () => handleMouseEnter('Export to PDF'),
                                        onMouseLeave: handleMouseLeave
                                    }}
                                >
                                    <FontAwesomeIcon icon={faFilePdf} size="lg" />
                                </Btn>
                                {tooltip === 'Export to PDF' && (
                                    <div style={{
                                        position: 'absolute',
                                        top: '-30px',
                                        left: '50%',
                                        transform: 'translateX(-50%)',
                                        backgroundColor: 'black',
                                        color: 'white',
                                        padding: '5px 10px',
                                        borderRadius: '3px',
                                        whiteSpace: 'nowrap',
                                        fontSize: '12px',
                                        zIndex: 1,
                                    }}>
                                        {tooltip}
                                    </div>
                                )}
                            </Col> */}
                        </Row>
                    </CardHeader>
                    <CardBody>
                        <Col sm="12" lg="12" xl="12">
                            <div className="table-responsive" style={{ overflowX: "auto" }}>
                                <Table style={{ minWidth: 1400 }}>
                                    <thead>
                                        <tr>
                                            <th scope="col" onClick={() => requestSort("transaction_date")}>
                                                Transaction Date{getSortIcon("transaction_date")}
                                            </th>
                                            <th scope="col" onClick={() => requestSort("receipt_number")}>
                                                Receipt No{getSortIcon("receipt_number")}
                                            </th>
                                            <th scope="col" onClick={() => requestSort("sku_code")}>
                                                SKU Code{getSortIcon("sku_code")}
                                            </th>
                                            <th scope="col" onClick={() => requestSort("sku_name")}>
                                                SKU Name{getSortIcon("sku_name")}
                                            </th>
                                            <th scope="col" onClick={() => requestSort("qty")}>
                                                Qty{getSortIcon("qty")}
                                            </th>
                                            <th scope="col" onClick={() => requestSort("rate")}>
                                                Rate{getSortIcon("rate")}
                                            </th>
                                            <th scope="col" onClick={() => requestSort("gross")}>
                                                Gross{getSortIcon("gross")}
                                            </th>
                                            <th scope="col" onClick={() => requestSort("net")}>
                                                Net{getSortIcon("net")}
                                            </th>
                                            <th scope="col" onClick={() => requestSort("tax")}>
                                                Tax{getSortIcon("tax")}
                                            </th>
                                            <th scope="col" onClick={() => requestSort("discount")}>
                                                Discount{getSortIcon("discount")}
                                            </th>
                                        </tr>
                                    </thead>

                                    <tbody>
                                        {currentPageData.map((row, index) => (
                                            <tr key={index}>
                                                <td>{row.transaction_date ? fmtDateTime(row.transaction_date) : ""}</td>
                                                <td>{row.receipt_number || ""}</td>
                                                <td>{row.sku_code || ""}</td>
                                                <td>{row.sku_name || ""}</td>
                                                <td>{row.qty ?? ""}</td>
                                                <td>{fmtMoney(row.rate)}</td>
                                                <td>{fmtMoney(row.gross)}</td>
                                                <td>{fmtMoney(row.net)}</td>
                                                <td>{fmtMoney(row.tax)}</td>
                                                <td>{fmtMoney(row.discount)}</td>
                                            </tr>
                                        ))}
                                    </tbody>

                                    <tfoot>
                                        {(() => {
                                            const totals = (reportData || []).reduce(
                                                (acc, r) => {
                                                    acc.qty += Number(r.qty || 0);
                                                    acc.gross += Number(r.gross || 0);
                                                    acc.net += Number(r.net || 0);
                                                    acc.tax += Number(r.tax || 0);
                                                    acc.discount += Number(r.discount || 0);
                                                    return acc;
                                                },
                                                { qty: 0, gross: 0, net: 0, tax: 0, discount: 0 }
                                            );

                                            return (
                                                <tr>
                                                    <td colSpan={4}>
                                                        <b>Total</b>
                                                    </td>
                                                    <td>
                                                        <b>{totals.qty}</b>
                                                    </td>
                                                    <td></td>
                                                    <td>
                                                        <b>{fmtMoney(totals.gross)}</b>
                                                    </td>
                                                    <td>
                                                        <b>{fmtMoney(totals.net)}</b>
                                                    </td>
                                                    <td>
                                                        <b>{fmtMoney(totals.tax)}</b>
                                                    </td>
                                                    <td>
                                                        <b>{fmtMoney(totals.discount)}</b>
                                                    </td>
                                                </tr>
                                            );
                                        })()}
                                    </tfoot>

                                </Table>
                            </div>


                            {reportData.length > 50 && (
                                <ReactPaginate
                                    previousLabel={'<<'}
                                    nextLabel={'>>'}
                                    breakLabel={'...'}
                                    breakClassName={'break-me'}
                                    pageCount={pageCount}
                                    marginPagesDisplayed={2}
                                    pageRangeDisplayed={5}
                                    onPageChange={handlePageClick}
                                    containerClassName={'pagination'}
                                    subContainerClassName={'pages pagination'}
                                    activeClassName={'active'}
                                    pageClassName={'page-item'}
                                    pageLinkClassName={'page-link'}
                                />
                            )}
                        </Col>
                    </CardBody>
                </Card>
            )}
        </Fragment>
    )
}

export default TenantItemwiseView